import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bienvenue, ${user.name}`);
      navigate(user.role === "admin" ? "/admin" : "/partner");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 fade-in">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-sage flex items-center justify-center text-white mb-4">
            <Calendar className="w-7 h-7" />
          </div>
          <h1 className="font-heading font-bold text-3xl text-ink">Connexion</h1>
          <p className="text-sm text-muted_text mt-2">Accédez à votre espace partenaire ou administrateur.</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white rounded-2xl border border-[#F0E0CC] p-6 sm:p-8 space-y-5"
          data-testid="login-form"
        >
          <div className="space-y-2">
            <Label htmlFor="email" className="text-ink font-medium">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-11 rounded-xl border-[#F0E0CC] focus-visible:ring-sage/20 focus-visible:border-sage"
              data-testid="login-email-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-ink font-medium">Mot de passe</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="h-11 rounded-xl border-[#F0E0CC] focus-visible:ring-sage/20 focus-visible:border-sage"
              data-testid="login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-xl bg-sage hover:bg-sage-dark text-white font-medium"
            data-testid="login-submit-button"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
          <p className="text-center text-sm text-muted_text">
            Pas encore de compte ?{" "}
            <Link to="/register" className="text-sage font-medium hover:underline" data-testid="link-to-register">
              Créer un compte partenaire
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
